// extracted by mini-css-extract-plugin
export var currencyInput = "_kq-1";
export var currencySymbol = "_kq-0";